/**
 * AI 分析错误状态：展示错误信息并提供刷新重试入口。
 */
import React, { memo } from 'react';
import { useIntl } from 'umi';
import { Button } from 'tea-component';
import AlertCard from '@/pages/datalab/components/AlertCard';
import type { IAiStatusErrorProps } from '../../types';
import './shared.scss';

const AiStatusError: React.FC<IAiStatusErrorProps> = (props) => {
  const { formatMessage } = useIntl();
  const { onRefresh, errorMessage } = props;

  return (
    <AlertCard
      className="dbl-ai-status dbl-ai-status--error"
      status="error"
      title={`${formatMessage({ id: 'dbl_common_load_fail' })}${
        errorMessage ? `: ${errorMessage}` : ''
      }`}
      description={(
        <Button
          type="link"
          className="dbl-ai-status__action"
          onClick={onRefresh}
        >
          {formatMessage({ id: 'dbl_common_refresh_click' })}
        </Button>
      )}
      />
  );
};

export default memo(AiStatusError);
